import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const JobIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.84181 5.03131C6.88681 3.81003 7.89133 2.8335 9.12361 2.8335H10.8772C12.1095 2.8335 13.114 3.81003 13.159 5.03131H14.002C15.0438 5.03131 15.9325 5.40315 16.5578 6.0748C17.1788 6.7418 17.4971 7.6577 17.4971 8.67535V10.5622C17.5015 10.603 17.5013 10.6436 17.4971 10.6835V13.5237C17.4971 14.5414 17.1788 15.4573 16.5576 16.1243C15.9322 16.796 15.0434 17.1678 14.0012 17.1678H5.99743C4.95557 17.1678 4.06706 16.7959 3.44194 16.1242C2.82118 15.4572 2.50308 14.5413 2.50308 13.5237V10.6822C2.49902 10.6431 2.49893 10.6033 2.50308 10.5635V8.67535C2.50308 7.65709 2.82291 6.7413 3.44416 6.0746C4.06962 5.4034 4.95781 5.03131 5.99743 5.03131H6.84181ZM7.99727 5.03131H12.0035C11.9598 4.4476 11.4721 3.98734 10.8772 3.98734H9.12361C8.52869 3.98734 8.04102 4.4476 7.99727 5.03131ZM3.65693 11.4436V13.5237C3.65693 14.3032 3.89828 14.9209 4.2866 15.3381C4.67057 15.7507 5.24078 16.014 5.99743 16.014H14.0012C14.7584 16.014 15.329 15.7507 15.7132 15.338C16.1018 14.9207 16.3432 14.3031 16.3432 13.5237V11.4437C12.1181 12.87 7.88266 12.87 3.65693 11.4436ZM16.3432 10.222C12.1111 11.7387 7.8898 11.7387 3.65693 10.222V8.67535C3.65693 7.8966 3.89917 7.27883 4.28832 6.86122C4.67325 6.44813 5.24377 6.18516 5.99743 6.18516H14.002C14.7587 6.18516 15.3291 6.44837 15.7132 6.86103C16.1018 7.27833 16.3432 7.896 16.3432 8.67535V10.222ZM7.9099 9.04489C7.9099 8.72627 8.16823 8.46797 8.48684 8.46797H11.5143C11.8329 8.46797 12.0912 8.72627 12.0912 9.04489C12.0912 9.36358 11.8329 9.62181 11.5143 9.62181H8.48684C8.16823 9.62181 7.9099 9.36358 7.9099 9.04489Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default JobIcon;
